import { oidcEarlyInit } from "oidc-spa/entrypoint";
import { browserRuntimeFreeze } from "oidc-spa/browser-runtime-freeze";


const { shouldLoadApp } = oidcEarlyInit({
BASE_URL: "/",

securityDefenses: {
...browserRuntimeFreeze({"excludes":["WebSocket","fetch"]}),


}
});

if (shouldLoadApp) {
import("./entry.client.tsx?oidc-spa-original=true");
}